import 'firebase/auth';

export default {
    selectedOrganization: () => {},
    selectedOrganizationPaymentSetup: () => false,
    isComplianceVisible: () => false,
    selectedOrganizationId: () => '',
    selectedOrganizationBillingEmail: () => '',
    selectedOrganizationActiveModels: () => [],
};
